import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

// images
import SocialLoginStrokeImage from "../../images/pages/signinpage/signin-stroke.svg";
import CheckboxArrowIconImage from "../../images/pages/signinpage/checkbox-arrow-icon.svg";
import IconFacebook from "../../images/pages/signinpage/icon_Facebook.svg";
import IconApple from "../../images/pages/signinpage/icon_apple.svg";
import IconGoogle from "../../images/pages/signinpage/icon_google.svg";

// components
import CommonInput from "../../components/input/CommonInput";

// data
import { DuplicateSignInAlert } from "../../data/alertData";
import SignAlert from "../../components/alert/SignAlert";

// api
import { getUser, signin } from "../../services/api/user";


function SignInPage() {
    const navigate = useNavigate();

    const [input, setInput] = useState({
        email: "",
        password: ""
    })
    const [rememberID, setRememberID] = useState(false);

    // alert창
    const [duplicateSignInAlert, setDuplicateSignInAlert] = useState(false);

    const handleInput = (value, type) => {
        setInput({
            ...input,
            [type]: value
        })
    }

    const executeGLMP = async () => {
        let userInfo = await getUser();
        if (userInfo.status === 200) {
            navigate("/");
            let href =
            process.env.REACT_APP_LAUNCHER_URL_PREFIX +
            ".metaverse://token=" +
            localStorage.getItem("token");
            window.location.href = href;
        } else {
            localStorage.removeItem("token");
            localStorage.removeItem("name");
            navigate("/sign-in");
            alert("Your login has expired. Please sign in again");
        }
    }

    const handleSignIn = async (event) => {
        event.preventDefault();

        // if(input.email==="test@test.com"){
        //     setDuplicateSignInAlert(true);
        //     return;
        // }

        setInput({
            email: input.email.trim(),
            password: input.password.trim()
        })

        try{            
            const res = await signin({
                username: input.email.trim(),
                password: input.password.trim()
            });

            localStorage.setItem("token", res.data.token);

            if(res.status === 200){
                localStorage.setItem("name", res.data.name);
                executeGLMP();
                navigate("/mypage");       
            }

        }catch(err){
            console.error(err);
            if(err.response){
                const errMessage = err.response.data.message;
                if(errMessage.includes("가입되지 않은")){
                    alert("Unsubscribed e-mail account. Please proceed with registration");
                }else if(errMessage.includes("Password")){
                    alert("E-mail or Password is incorrect. Please type it again.");
                }else{
                    alert(err.response.data.message);
                } 
            }                       
        }

    }

    useEffect(()=>{
        const rememberId = localStorage.getItem("rememberId", input.email);
        if(rememberId){
            setInput({
                ...input,
                email: rememberId
            });
            setRememberID(true);
        }        
    },[])

    useEffect(()=>{
        if(rememberID){
            localStorage.setItem("rememberId", input.email);
        }else{
            localStorage.removeItem("rememberId");
        }
    },[rememberID, input.email])

    return (
        <div className="SignInPage">
            <form onSubmit={handleSignIn} noValidate>
                <CommonInput
                    type="email"
                    legend="E-mail"
                    placeholder="Enter your e-mail."
                    handleInput={handleInput}
                    input={input}
                />
                <CommonInput
                    type="password"
                    legend="Password"
                    placeholder="Enter your password."
                    handleInput={handleInput}
                    input={input}
                />

                <div className="SignIn-Option">
                    <div className="Checkbox-Remember">
                        <input
                            type="checkbox"
                            id="checkbox-remember-id"
                            onClick={()=>setRememberID(!rememberID)}
                        />
                        <label htmlFor="checkbox-remember-id">
                            {rememberID ?
                                <img src={CheckboxArrowIconImage} alt="checkbox arrow icon"/>
                                : <div />
                            }
                        </label>
                        <label htmlFor="checkbox-remember-id">
                            Remember Me
                        </label>
                    </div>
                    <Link
                        className="ForgotPWLink"
                        to="/forgot-password"
                    >
                        Forgot password?
                    </Link>
                </div>

                <button
                    className="SigninButton"
                    type="submit"
                    disabled={!input.email || !input.password}
                >Sign in</button>
            </form>
            {/* <div className="SocialLogin">
                <div className="SocialLogin-Stroke">
                    <img src={SocialLoginStrokeImage} alt="social login stroke" />
                    <div>or</div>
                    <img src={SocialLoginStrokeImage} alt="social login stroke" />
                </div>
                <div className="IconGroup">
                    <button>
                        <img src={IconFacebook} alt="facebook social login icon" />
                    </button>
                    <button>
                        <img src={IconApple} alt="apple social login icon" />
                    </button>
                    <button>
                        <img src={IconGoogle} alt="google social login icon" />
                    </button>
                </div>
            </div> */}
            {duplicateSignInAlert && <SignAlert data={DuplicateSignInAlert} setAlert={setDuplicateSignInAlert} />}
        </div>
    );
}

export default SignInPage;